import { useQuery } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchPublisherPrefixHistory, } from "../api/publisherService";
export var usePublisherPrefixHistoryData = function (publisherId) {
    var _a;
    var ky = useOkapiKy();
    var _b = useQuery(["publisher-prefix-history", publisherId], function () { return fetchPublisherPrefixHistory(ky, publisherId); }, {
        enabled: !!publisherId,
    }), data = _b.data, isLoading = _b.isLoading, isError = _b.isError, refetch = _b.refetch;
    var prefixHistoryData = (_a = data === null || data === void 0 ? void 0 : data.items) !== null && _a !== void 0 ? _a : [];
    return {
        prefixHistoryData: prefixHistoryData,
        isLoading: isLoading,
        isError: isError,
        refetch: refetch,
    };
};
